import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { RenderIf } from "../../../utils/RenderIf";

export default function ClienteSection({ S, data }) {
  return (
    <View style={[S.box, { height: "auto", marginTop: 10 }]}>
      <Text style={S.label}>Datos del Cliente</Text>

      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          marginTop: 6,
        }}
      >
        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Cliente:</Text> {data.clienteNombre}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>RUC:</Text> {data.clienteRuc}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>DV:</Text> {data.clienteDv}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Dirección:</Text> {data.clienteDireccion}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Teléfono:</Text> {data.clienteTelefono}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Fecha:</Text> {data.fechaEmision}
        </Text>

        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>Punto:</Text> {data.puntoFacturacion}
        </Text>
      </View>

      <RenderIf isTrue={data.aditional_info}>
        <Text style={{ marginRight: 10 }}>
          <Text style={S.bold}>{data.aditional_info}</Text>
        </Text>

      </RenderIf>
    </View>
  );
}